{
  "title": "SABO Logistics — B2B e-commerce logistics from the USA and EU to CIS",
  "description": "Cross-border forwarding for business since 2016: US and EU warehouses, consolidation, export preparation, customs clearance and delivery to CIS countries.",
  "canonicalUrl": "https://www.sabologistics.com/",
  "themeColor": "#000000",
  "ogImagePath": "/partners/sabo/og-image.png"
}
